

import { Vue, Component, Prop } from "vue-property-decorator";
import { profileEntity } from "@/models/modules/profile/entity";
import IbBadge from "@/components/IBBadge/IBBadge.vue";

@Component({
	components: {
		IbBadge
	}
})
export default class ItemWithIconAndBadge extends Vue {

	@Prop(Number) readonly badgeText: number | undefined;

	@Prop(String) readonly badgeImgUrl!: string;

	@Prop({ type: String, default: "" }) readonly text!: string;

	@Prop({ type: [ String, Object ], default: "" }) readonly urlRoute!: string;

	@Prop(String) readonly imgUrl: string | undefined;

	@Prop(String) readonly hoveredImgUrl: string | undefined;

	@Prop({ type: Boolean, default: false }) readonly isActive!: boolean;

	@Prop({ type: Boolean, default: false }) readonly loading!: boolean;

	@Prop({ type: String, default: "" }) readonly role!: string;

	@Prop(Boolean) readonly badgePrimary?: boolean

	get currentRole() {
		return profileEntity.profileData?.role;
	}

}

